// src/pages/DevHub/components/DevPageLayout.tsx
// Replaces: .dev-service-page, .dev-header-clean, .dev-header-content, .dev-subtitle, .dev-container-clean

import React from 'react';
import { cn } from '../../../lib/utils';
import { Typography } from '../../../components/ui/typography';

interface DevPageLayoutProps {
    title: string;
    subtitle?: string;
    children: React.ReactNode;
    className?: string;
}

const DevPageLayout: React.FC<DevPageLayoutProps> = ({ title, subtitle, children, className }) => {
    return (
        /*
         * .dev-service-page:
         *   min-height: 100vh;
         *   background-color: #f8f9fa;
         *   color: #202124;
         *   font-family: 'Inter', -apple-system, BlinkMacSystemFont, inherit;
         */
        <div className={cn('min-h-screen bg-white font-brand text-[#202124]', className)}>

            {/*
             * .dev-header-clean:
             *   padding: 48px 24px 40px;
             *   background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
             *   text-align: center;
             *   border-bottom: 1px solid #dadce0;
             * @media (max-width: 768px):
             *   padding: 40px 16px 32px;
             */}
            <header className={cn(
                'pt-[48px] px-[24px] pb-[40px]',
                'text-center',
                'max-[768px]:pt-[40px] max-[768px]:px-[16px] max-[768px]:pb-[32px]',
            )}>
                {/*
                 * .dev-header-content:
                 *   max-width: 800px;
                 *   margin: 0 auto;
                 */}
                <div className="max-w-[800px] mx-auto">
                    {/*
                     * .dev-header-clean h1:
                     *   font-size: 2.25rem;
                     *   font-weight: 400;
                     *   color: #202124;
                     *   margin: 0 0 12px 0;
                     *   letter-spacing: -0.5px;
                     * @media (max-width: 768px): font-size: 1.75rem;
                     */}
                    <Typography variant="hero-title" as="h1" weight="light" className="mb-6 text-[#121317]">
                        {title}
                    </Typography>

                    {/*
                     * .dev-subtitle:
                     *   font-size: 1.125rem;
                     *   color: #54585d;
                     *   margin: 0;
                     *   line-height: 1.6;
                     */}
                    {subtitle && (
                        <Typography variant="hero-subtitle" weight="normal" className="m-0 text-[#54585d]">
                            {subtitle}
                        </Typography>
                    )}
                </div>
            </header>

            {/*
             * .dev-container-clean:
             *   max-width: 1200px;
             *   margin: 0 auto;
             *   padding: 40px 24px;
             */}
            <div className="max-w-[1200px] mx-auto px-[24px] py-[40px]">
                {children}
            </div>
        </div>
    );
};

export default DevPageLayout;
